// ** Custom Hooks
import { useSkin } from "@hooks/useSkin";
import { Controller, useForm } from "react-hook-form";
// ** Custom Components
import InputPasswordToggle from "@components/input-password-toggle";
// ** Reactstrap Imports
import {
  Button,
  Form,
  FormFeedback,
  Input,
  Spinner,
} from "reactstrap";

// ** Illustrations Imports
import { ReactComponent as Logo } from "@src/assets/images/logo/logo.svg";

// ** Styles
import "@styles/react/pages/page-authentication.scss";
import {AuthNavLinks, useRegisterUser} from "@features/auth";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

const passwordSchema = z
  .string()
  .min(8, "Use 8 characters")
  .regex(/[a-zA-Z]/, "Use at least 1 letter")
  .regex(/\d/, "Use at least 1 number")
  .regex(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/, "Use at least 1 symbol");

const signUpSchema = z
  .object({
    username: z.string().min(1, "Username is required"),
    email: z.string().email("Invalid email address"),
    password: passwordSchema,
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ["confirmPassword"], // path of error
  });

export const Signup = () => {
  // ** Hooks
  const { skin } = useSkin();
  const registerUserMutation = useRegisterUser();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: zodResolver(signUpSchema) });

  const submitForm = (data) => {
    const { firstName, username, lastName, email, password } = data;
    registerUserMutation.mutateAsync({
      data: {
        first_name: firstName,
        last_name: lastName,
        username: username,
        email,
        password,
      },
    });
  };

  return (
      <div className={" auth-wrapper auth-basic"}>
          <div className="auth-inner my-2">
              <div className={'d-flex justify-content-center align-items-center gap-50 pb-2'}>
                  <Logo/>
                  <h1 className={'text-center fw-bolder mb-0'}>
                      PmChess
                  </h1>
              </div>
              <AuthNavLinks/>
              <Form
                  className={"rounded-3 border p-2"}

                  onSubmit={handleSubmit(submitForm)}>
                  <div className="form-floating ">
                      <Controller
                          id="username"
                          name="username"
                          rules={{required: true}}
                          control={control}
                          render={({field}) => (
                              <Input
                                  className=""
                                  type="text"
                                  id="username"
                                  placeholder=""
                                  {...field}
                              />
                          )}
                      />
                      <label htmlFor="username">User Name</label>
                  </div>
                  {errors.username && (
                      <FormFeedback className="d-block mt-50">
                          {errors.username.message}
                      </FormFeedback>
                  )}

                  <div className="form-floating mt-2">
                      <Controller
                          id="email"
                          name="email"
                          rules={{required: true}}
                          control={control}
                          render={({field}) => (
                              <Input
                                  className=""
                                  type="text"
                                  id="email"
                                  placeholder=""
                                  {...field}
                              />
                          )}
                      />
                      <label htmlFor="email">Email</label>
                  </div>
                  {errors.email && (
                      <FormFeedback className="d-block mt-50">
                          {errors.email.message}
                      </FormFeedback>
                  )}


                  <div className="mt-2">
                      <Controller
                          id="password"
                          name="password"
                          rules={{required: true}}
                          control={control}
                          render={({field}) => (
                              <InputPasswordToggle
                                  label="Password"
                                  id="password"
                                  className="input-group-merge form-floating "
                                  placeholder=" "
                                  size="lg"
                                  {...field}

                                  // onBlur={onBlur}
                                  // value={value}
                                  // name={name}
                                  // ref={ref}
                                  // onChange={(e) => handleChangePassword(e, onChange)}
                              />
                          )}
                      />
                  </div>
                  {errors.password && (
                      <FormFeedback className="d-block mt-50">
                          {errors.password.message}
                      </FormFeedback>
                  )}

                  <div className="mt-2">
                      <Controller
                          id="confirmPassword"
                          name="confirmPassword"
                          rules={{required: true}}
                          control={control}
                          render={({field}) => (
                              <InputPasswordToggle
                                  label="Confirm Password"
                                  id="confirmPassword"
                                  className="input-group-merge form-floating "
                                  placeholder=" "
                                  size="lg"
                                  {...field}
                                  // onBlur={onBlur}
                                  // value={value}
                                  // name={name}
                                  // ref={ref}
                                  // onChange={(e) => handleChangePassword(e, onChange)}
                              />
                          )}
                      />
                  </div>
                  {errors.confirmPassword && (
                      <FormFeedback className="d-block mt-50">
                          {errors.confirmPassword.message}
                      </FormFeedback>
                  )}

                  {/*{renderPasswordValidation()}*/}

                  <Button
                      type="submit"
                      className={'mt-2'}
                      color="primary"
                      size="lg"
                      block
                  >
                      {registerUserMutation.isLoading ||
                      registerUserMutation.isPending ? (
                          <Spinner/>
                      ) : (
                          "Sign up"
                      )}
                  </Button>
              </Form>

              <div className={'mt-1 text-center'}>
                  <small>
                      By signing up, you agree to our Terms, Data Policy and Cookies Policy.
                  </small>
              </div>
          </div>
      </div>
  );
};
